var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('navbar-header'),_c('banner',{attrs:{"topImg":_vm.topImg}}),_c('news-list-row',{attrs:{"topList":_vm.topList},on:{"update":_vm.pageChange}}),_c('NewsListColumn',{attrs:{"list":_vm.list}}),_c('nav-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }